import React from "react";
import { Box, Typography } from "@mui/material";

function Header() {
  return (
    <Box height={64} display="flex" alignItems="center" px={3} py={2}>
      <Typography variant="h6">Dashboard</Typography>
    </Box>
  );
}

export default Header;
